import { render } from "./EmpfehlungList.vue?vue&type=template&id=7a1c9bb1"
import script from "./EmpfehlungList.vue?vue&type=script&lang=js"
export * from "./EmpfehlungList.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__